/* DO NOT FORGET to add export of this file to /src/store/reducers/index.js */
import * as FP from '../../utils/fp-js';

export const newMessageReceiverId = (state, action) =>
  FP.match(action.type)
    .on('SET_newMessageReceiverId', action.payload)
    .otherwise(state);
